import React from 'react'
import PropTypes from 'prop-types'

const SummarySection = ({
  isOpen,
  toggleSection,
  isDifferent,
  isNew,
  selected,
  formData,
  handleSelectionChange,
  handleInputChange,
  isRegistrationFlow,
}) => {
  const maxLength = 1300
  const remaining = Math.max(maxLength - formData.analyseData.summary.length, 0)

  return (
    <div className="mb-5">
      <div className="mb-3 d-flex align-items-center" onClick={() => toggleSection('summary')} style={{ cursor: 'pointer' }}>
        <span className="form-title-chip rounded-circle mr-2">2</span>

        <h4 className="mb-0">Vos attentes</h4>

        <span className={`badge badge-${isNew ? 'primary text-white' : (isDifferent ? 'info' : 'success')} ml-2`}>
          { isNew ? 'Nouveau' : (isDifferent ? 'Différent' : 'Identique') }
        </span>

        <small className="helper ml-3">
          {remaining} caractère{remaining > 1 ? 's' : ''} restant{remaining > 1 ? 's' : ''}
        </small>

        <span className="ml-auto h3 text-secondary mb-0">{isOpen ? '-' : '+'}</span>
      </div>

      { isOpen && (
        <div className="row">
          <div className={`col-md-${isDifferent ? '6' : '12'}`}>
            <div className={`mb-3 ${isDifferent ? 'p-3 border rounded' : ''} ${selected === 'analyseData' ? '' : 'border-light'}`}>
              { isDifferent ? (
                <div className="custom-control custom-switch mb-2">
                  <input
                    className="custom-control-input"
                    type="checkbox"
                    id="summary-analyse"
                    checked={selected === 'analyseData'}
                    onChange={() => handleSelectionChange('general', 'summary', 'analyseData')}
                  />

                  <label className="custom-control-label" htmlFor="summary-analyse">
                    Nouvelle donnée du CV
                  </label>
                </div>
              ) : null }

              <div style={{ opacity: isDifferent && selected !== 'analyseData' ? 0.5 : 1 }}>
                <textarea
                  className="form-control"
                  name="summary"
                  rows="5"
                  maxLength={maxLength}
                  value={formData.analyseData.summary}
                  disabled={selected !== 'analyseData'}
                  onChange={(e) => handleInputChange('analyseData', 'summary', e.target.value)}
                />
              </div>
            </div>
          </div>

          { isDifferent ? (
            <div className="col-md-6">
              <div className={`p-3 mb-3 border rounded ${selected === 'freelanceData' ? '' : 'border-light'}`}>
                <div className="custom-control custom-switch mb-2">
                  <input
                    className="custom-control-input"
                    type="checkbox"
                    id="summary-freelance"
                    checked={selected === 'freelanceData'}
                    onChange={() => handleSelectionChange('general', 'summary', 'freelanceData')}
                  />

                  <label className="custom-control-label" htmlFor="summary-freelance">
                    Donnée actuelle
                  </label>
                </div>

                <div style={{ opacity: isDifferent && selected !== 'freelanceData' ? 0.5 : 1 }}>
                  <textarea
                    className="form-control"
                    name="summary"
                    rows="5"
                    maxLength={maxLength}
                    value={formData.freelanceData.summary}
                    disabled={selected !== 'freelanceData'}
                    onChange={(e) => handleInputChange('freelanceData', 'summary', e.target.value)}
                  />
                </div>
              </div>
            </div>
          ) : null }
        </div>
      )}
    </div>
  )
}

SummarySection.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleSection: PropTypes.func.isRequired,
  isDifferent: PropTypes.bool.isRequired,
  isNew: PropTypes.bool.isRequired,
  selected: PropTypes.string.isRequired,
  formData: PropTypes.object.isRequired,
  handleSelectionChange: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  isRegistrationFlow: PropTypes.bool.isRequired,
}

SummarySection.defaultProps = {
  isRegistrationFlow: false,
}

export default SummarySection
